import { render, staticRenderFns } from "./NeedEditProposals.vue?vue&type=template&id=7d173718&scoped=true&"
import script from "./NeedEditProposals.vue?vue&type=script&lang=js&"
export * from "./NeedEditProposals.vue?vue&type=script&lang=js&"
import style0 from "./NeedEditProposals.vue?vue&type=style&index=0&id=7d173718&prod&lang=css&"
import style1 from "./NeedEditProposals.vue?vue&type=style&index=1&id=7d173718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d173718",
  null
  
)

export default component.exports